// third-party
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  error: null,
  checkout: {
    step: 0,
    vehicles: [],
    discount: 0,
    shipping: 0,
    billing: null,
    payment: {
      type: 'free',
      method: 'card',
      card: ''
    }
  }
};

// ==============================|| SLICE - CART ||============================== //

const slice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
  }
});

// Reducer
export default slice.reducer;